export enum Bg {
  one = 'one',
  two = 'two',
  three = 'three',
  four = 'four',
}

export interface Props {
  bg?: Bg,
}
